import * as React from 'react'

import { ProductDetailSlotsProvider } from '@grandvisionhq/fun-products'
import { WishlistButton } from '@grandvisionhq/fun-wishlist/button'
import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/frames'
import { CrossSellProductsGraphContainer } from '@grandvisionhq/www-next/slot-components/CrossSellProductsGraphContainer'
import { SSP } from '@grandvisionhq/www-next/slot-components/SSP'

import { composePDP } from '../../../components/hocs/compose-pdp'
import { getDeliveryIndicatorConfig, getSpecifications } from '../../../configuration'
import { getAllowedExtras } from '../../../util/get-allowed-extras'

import '@grandvisionhq/reviews/dist/index.css'

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const {
    sspData,
    product: { productType },
  } = props
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()
  const specificationConfiguration = getSpecifications(productType)

  return (
    <ProductDetailSlotsProvider
      slots={{
        SecondaryProductInfoSlot: CrossSellProductsGraphContainer,
        SSP: () => <SSP lensExtrasResolver={getAllowedExtras} sspData={sspData} />,
        WishlistButton,
      }}
    >
      <Page
        {...props}
        deliveryIndicatorConfig={deliveryIndicatorConfig}
        specificationConfiguration={specificationConfiguration}
      />
    </ProductDetailSlotsProvider>
  )
}

const getInitialProps = Page.getInitialProps
if (getInitialProps) {
  ProductDetailPage.getInitialProps = (ctx) =>
    getInitialProps({ ...ctx, pageConfig: { requiresSSPFetch: true } })
}

export default composePDP<Props>(ProductDetailPage)
